import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Trash2, MapPin } from "lucide-react";
import { api, errMsg, fmtDate } from "@/lib/api";

const Conversation = ({ c, onRead, onDelete }) => (
  <details className="card-fv group" data-testid={`admin-chat-${c.session_id}`} onToggle={(e) => e.target.open && !c.read && onRead(c)}>
    <summary className="flex cursor-pointer list-none flex-wrap items-center gap-x-4 gap-y-1 p-5">
      {!c.read && <span className="h-2.5 w-2.5 rounded-full bg-[#8B2B22]" data-testid="admin-chat-unread-dot" />}
      <span className="font-semibold text-[#1D3324] flex-1 min-w-[200px] truncate">{c.items.find((m) => m.role === "user")?.text || "(sin mensajes)"}</span>
      <span className="text-xs text-[#5C635E] inline-flex items-center gap-1"><MapPin size={12} />{[c.city, c.country].filter(Boolean).join(", ") || "—"}</span>
      <span className="text-xs text-[#5C635E]">{(() => { const n = c.items.filter((m) => m.role === "user").length; return `${n} ${n === 1 ? "pregunta" : "preguntas"}`; })()} · {fmtDate(c.updated_at)}</span>
      <button onClick={(e) => { e.preventDefault(); onDelete(c); }} data-testid={`admin-chat-delete-${c.session_id}`} className="p-1.5 text-[#5C635E] hover:text-[#8B2B22]" aria-label="Eliminar"><Trash2 size={16} /></button>
    </summary>
    <div className="space-y-3 border-t border-[#8B2B22]/10 p-5">
      {c.items.map((m, i) => (
        <div key={i} className={m.role === "user" ? "text-right" : ""}>
          <p className={`inline-block max-w-[85%] whitespace-pre-line px-4 py-2 text-sm text-left ${m.role === "user" ? "bg-[#8B2B22] text-white" : "bg-[#F3EAD7]/70"}`}>{m.text}</p>
        </div>
      ))}
    </div>
  </details>
);

export const AdminChats = () => {
  const [chats, setChats] = useState(null);
  const load = () => api.get("/admin/chats").then((r) => setChats(r.data)).catch((e) => toast.error(errMsg(e)));
  useEffect(() => { load(); }, []);
  const onRead = async (c) => { await api.patch(`/admin/chats/${c.session_id}`, { read: true }); setChats((l) => l.map((x) => (x === c ? { ...x, read: true } : x))); };
  const onDelete = async (c) => {
    if (!window.confirm("¿Eliminar esta conversación?")) return;
    await api.delete(`/admin/chats/${c.session_id}`);
    setChats((l) => l.filter((x) => x !== c));
    toast.success("Conversación eliminada");
  };

  if (!chats) return null;
  return (
    <div className="space-y-3" data-testid="admin-chats">
      <p className="text-sm text-[#5C635E]">Conversaciones de visitantes con el Asesor Brangus (IA). Abra una para leerla completa.</p>
      {chats.length === 0 && <p className="card-fv p-8 text-[#5C635E]" data-testid="admin-chats-empty">Todavía no hay conversaciones.</p>}
      {chats.map((c) => <Conversation key={c.session_id} c={c} onRead={onRead} onDelete={onDelete} />)}
    </div>
  );
};
